export default __webpack_public_path__ + "static/media/quetion-options.bc9c5243.svg";